<!-- @format -->

@if (this.control) {
  @if (label) {
    <label [for]="id" [ngClass]="[labelState]">{{ label }}</label>
  }
  <div class="input-and-type">
    <input
      (keydown)="arrowKeyMovement($event)"
      [attr.disabled]="disabled || null"
      [id]="id"
      [attr.aria-describedby]="id + '_errors'"
      [formControl]="control"
      class="form-control"
      data-cy="number-input"
      placeholder="{{ this.placeholder }}"
      type="number" />
    @if (valueType) {
      <span class="type-block">{{ valueType }}</span>
    }
  </div>
  <sis-validation-errors [control]="control" [formFieldId]="id" [ariaLive]="false" />
}
